<template>
  <iText
    v-if="editMode"
    v-bind="$attrs"
  >
    {{ entity.text }}
  </iText>
  <iEditor
    v-else-if="storySegments.length"
    v-bind="$attrs"
    ref="editor"
    :key="playbackVersion"
    preview
    :branding-styles="getCssMappedConfiguration"
    :segments="renderableSegments"
    height="auto"
    overflow="none"
    variant="builder"
    width="fill"
  />
</template>

<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import { camelToSnakeCase } from "@bloglovin/vue-framework";
import { mapState } from "pinia";
import useBrandingStore from "%/dynamic-component-editor/stores/branding-store";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import { StoryVideoPlaybackMixin } from "%/mixins/story-video-playback-mixin";
import { storyBodySegments } from "%/lib/story-media";
import HideStoryMedia from "%/dynamic-component-editor/options/hide-story-media";

export default {
  name: "StoryContent",
  mixins: [StoryPageElementMixin, StoryVideoPlaybackMixin],
  inheritAttrs: false,
  optionBundles: [
    LayoutWidthHeightOptions,
  ],
  options: [
    HideStoryMedia,
  ],
  elementPanelSettings: {
    displayIcon: "text",
    elementType: "element",
  },
  computed: {
    hidesUnresolvedMedia() {
      return !this.editMode;
    },
    ...mapState(useBrandingStore, [
      "getCssMappedConfiguration",
    ]),
    // Segment source the playback mixin resolves media-backed videos against.
    playbackSegments() {
      return this.storySegments;
    },
    hideStoryMedia() {
      return this.getOptionValue(HideStoryMedia);
    },
    storySegments() {
      return storyBodySegments(this.entity, { hideStoryMedia: this.hideStoryMedia })
          .map(segment => {
            const formattedSegment = {};
            Object.keys(segment).forEach(segmentKey => {
              formattedSegment[camelToSnakeCase(segmentKey)] = segment[segmentKey];
            });
            return formattedSegment;
          });
    },
  },
};
</script>

